
    <div class="fx_modal_container mall-batch-modal" appModalDrag>
      <div class="fx_modal_title {{fxMedia == 'mobile' ? 'p-0' : 'fx_modal_title_border_bottom'}}">
          <div class="fx_le_title {{fxMedia == 'mobile' ? 'text-center d-flex flex-column' : ''}}">
            <span class="{{fxMedia == 'mobile' ? 'fs-5 mb-3' : ''}}">{{ title }}</span> 
            <span class="text-center">
              <i class="mall-batch-modal-icon rounded-circle anticon anticon-{{iconType}} p-2 text-danger fs-1 mb-4 mx-0" *ngIf="fxMedia == 'mobile'" ></i> 
            </span>              
          </div>
          <div class="fx_ri_full" *ngIf="fxMedia != 'mobile'">
                <ul class="">
<!--                    <li class="fx_modal_search">-->
<!--                      <dw-input-group dwSuffixIcon="anticon anticon-search">-->
<!--                        <input type="text" dw-input placeholder="请输入筛选条件" [(ngModel)]="searchText" (keyup)="($event.which === 13)?jump():0">-->
<!--                      </dw-input-group>-->
<!--                    </li>-->
                    <li>
                        <ol class="fx_modal_icon-group">
                          <li>
                            <i class="anticon anticon-close fx_modal_close_btn" (click)="fxCloseModal()"></i>
                          </li>
                        </ol>
                    </li>
                </ul>
          </div>
          <div class="position-absolute end-0 top-0" *ngIf="fxMedia == 'mobile'">
            <i class="anticon anticon-close fs-1 p-3 m-0" (click)="fxCloseModal()"></i>
          </div>

      </div>
      <div class="fx_modal_content {{fxMedia == 'mobile' ? 'p-0' : ''}}">
      <div class="fx-modal-content-more" style="overflow-y: hidden;">
        <div dw-row class="fx_batch_status {{fxMedia == 'mobile' ? 'pt-0' : ''}}">
          <dw-col dwSpan="" class="align-items-center justify-content-center">
            <div class="justify-content-center d-flex">
            <i class="mall-batch-modal-icon rounded-circle anticon anticon-exclamation p-2 text-danger fs-1 mx-0 fx_mall_batch_modal_icon_background" *ngIf="fxMedia != 'mobile'"></i>
            </div>
            <div class="justify-content-center d-flex">
            <span class="fx_success_text">执行成功 <b>{{successCount}}</b> 笔， 异常 <b class="color-error">{{failCount}}</b> 笔！</span>
            </div>
            </dw-col>
          <dw-col dwSpan="9">

          </dw-col>
        </div>
      </div>

      <div class="fx-modal-content-more fx-modal-message-panel border rounded mall-batch-content p-3 {{fxMedia == 'mobile' ? '' : 'fx_modal_content_more_background'}}" id="fx-modal-message-panel">
      <div dw-row>
      <label class="stay-left check-all" dw-checkbox [(ngModel)]="allchecked"  (ngModelChange)="allChecked($event)" *ngIf="isRemind">全选</label>
      </div>
        <div dw-row *ngFor="let error of errorInfos">
          <div class="{{fxMedia == 'mobile' ? 'fx_warring_title d-flex justify-content-center px-0 h-auto' : 'fx_warring_title2'}}" style="padding:0 10px 0 0;color:#333;">
          <label class="stay-left check-erroritem" dw-checkbox [(ngModel)]="error.checked" (ngModelChange)="updateSingleChecked()" *ngIf="error.isRemind"></label>
          <span class="{{fxMedia == 'mobile' ? 'px-0' : ''}}" [innerHTML]="error.message | fxHighlight: searchText"></span>
          </div>
          <div dw-row class="fx-modal-message-detail {{fxMedia == 'mobile' ? 'px-0' : ''}}" *ngFor="let info of error.itemInfos">
            <div dw-col dwSpan="21" class="d-flex {{fxMedia == 'mobile' ? ' flex-column' : ''}}" style="padding:5px 0;">
              <div class="{{fxMedia == 'mobile' ? ' d-flex align-items-center' : ''}}">
                <label class="stay-left check-infoitem" dw-checkbox [(ngModel)]="info.checked" *ngIf="info.isRemind && info.showChecked"></label>
                <i class="anticon anticon-info-circle color-warning{{fxMedia == 'mobile' ? 'ms-0 me-2' : ''}}" *ngIf="info.isRemind == '2'"></i>
                <i class="anticon anticon anticon-exclamation-circle text-warning color-error{{fxMedia == 'mobile' ? 'ms-0 me-2' : ''}}" *ngIf="info.isRemind != '2'"></i>
                <span [innerHTML]="info.title | fxHighlight: searchText" style="padding:0 10px 0 0;color:#333;"></span>
                <span *ngIf="info.errorCode">(</span>
                <span [innerHTML]="info.errorCode | fxHighlight: searchText" class="fx_search_text"></span>
                <span *ngIf="info.errorCode">) </span>
              </div>
              <span [innerHTML]="info.content | fxHighlight: searchText" class="color-error {{fxMedia == 'mobile' ? 'error-content' : ''}}"></span>
              <span *ngIf="info.program_name" class="color-error">请查询
                <a href="javascript: void(0)"
                   (click)="openMenu(info.program_no)">{{info.program_name}}</a> 作业</span>
            </div>
            <div dw-col dwspan="3" style="float: right;padding:6 0;" *ngIf="info.hasMoreContent">
              <i class="anticon anticon-plus-square-o color-info" *ngIf="!info.showMoreContent"
                 (click)="info.showMoreContent = !info.showMoreContent"></i>
              <i class="anticon anticon-minus-square-o color-info" *ngIf="info.showMoreContent"
                 (click)="info.showMoreContent = !info.showMoreContent"></i>
            </div>
            <div dw-col dwspan="24" *ngIf="info.hasMoreContent && info.showMoreContent">
              <textarea rows="4" dw-input [ngModel]="info.moreInfo" disabled></textarea>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="fx_modal_footer {{fxMedia == 'mobile' ? 'border-0 px-0' : ''}}">
        <div class="{{fxMedia == 'mobile' ? 'd-flex flex-column' : ''}}">
          <div dwType="flex" dwAlign="middle">
            <i class="anticon anticon-clock-circle-o fx_default_color"></i>
            <span>{{ time }}</span>
          </div>
          <div class="{{fxMedia == 'mobile' ? 'text-end mt-2' : ''}}">
            <div dw-row dwType="flex" dwJustify="end">
              <button [ngClass]="fxMedia == 'mobile' ? 'rounded-pill px-4 py-1 bg-white text-secondary mall-batch-modal-footer-defaultbtn' : 'bg-white text-secondary mall-batch-modal-footer-defaultbtn border borderhover'" dw-button [dwType]="'default'" (click)="onClickExport()">导出</button>
              <button class="bg-white text-secondary mall-batch-modal-footer-defaultbtn border borderhover" dw-button [dwType]="'default'" (click)="onClickCancel()" *ngIf="fxMedia != 'mobile'">取消</button>
              <button [ngClass]="fxMedia == 'mobile' ? 'rounded-pill px-4 py-1 bg-white text-secondary mall-batch-modal-footer-defaultbtn' : ''" dw-button [dwType]="'primary'" (click)="onClickContinue()" [disabled]="selectedItem.length < 1" *ngIf="isRemind">继续执行</button>
              <button [ngClass]="fxMedia == 'mobile' ? 'rounded-pill px-4 py-1 border border-danger bg-danger text-whiten' : 'border border-danger bg-danger text-whiten'"  dw-button [dwType]="'primary'" (click)="onClickContinue()" *ngIf="!isRemind">确定</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  